import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import Api from '../../../../_helpers/Api';

//images
import docIcon from '../../../../assets/img/icons/document.png';
import closeIcon from '../../../../assets/img/icons/close.png';
import loader from '../../../../assets/img/loader.svg';
import MultiSelect from "react-multi-select-component";
import { trans } from '../../../../_providers/Translation';

function AddOrEditGroup(props, ref) {

    const defaultData = {
        selectedEmployees: []
    };

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: defaultData,
        loading: false,
    });

    const [employees, setEmployees] = useState({
        loading: true,
        data: []
    });

    const [validations, setValidations] = useState(null);

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: defaultData
            }));
            handleShow();
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false,
                data: defaultData,
            }));
            handleShow();
        },
        hide: () => {
            handleHide();
        }
    }));

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`partners/groups/find?id=${popup.editId}`)
                .then(res => {

                    let data = res.data;
                    let employees = res.data.employees || [];
                    let selectedEmployees = [];

                    employees.map(m => {
                        selectedEmployees.push({
                            label: `${m.name} ${m.lastname}`,
                            value: m.id
                        });
                    });

                    data.selectedEmployees = selectedEmployees;

                    setPopup(prev => ({
                        ...prev,
                        data: data,
                    }));
                });
        }

    }, [popup.edit]);

    useEffect(() => {
        loadEmployees();
    }, []);

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }));
        }, 50);
    }

    const handleHide = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }));
        }, 50);
    }

    const loadEmployees = () => {

        setEmployees(prev => ({
            ...prev,
            loading: true
        }));

        let url = 'partners/employees/technicians?id=' + props.partnerId;

        Api.get(url)
            .then(res => {

                let data = [];

                res.data.map(m => {
                    data.push({
                        label: `${m.name} ${m.lastname}`,
                        value: m.id
                    });
                });

                setEmployees(prev => ({
                    ...prev,
                    loading: false,
                    data: data
                }));
            }).catch(err => {
                setEmployees(prev => ({
                    ...prev,
                    loading: false
                }));
            });

    }

    const handleSave = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url;

        if (popup.edit) {
            url = 'partners/groups/edit';
        } else {
            url = 'partners/groups/add';
        }

        let data = new FormData(e.target);

        data.append('partner_id', props.partnerId);

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId);
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data);
                }

                handleHide(e);

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }

    const handleInputChange = e => {
        let name = e.target.name;
        let val = e.target.value;

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    const handleEmployeesChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedEmployees: data
            }
        }));
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary medium`} onSubmit={handleSave}>
                <h2 className="head">
                    <img src={docIcon} alt="document" className="document-icon" />

                    {popup.edit ? trans('headings.editGroup') : trans('headings.addGroup')}

                    <img src={closeIcon} alt="close" className="close-icon" onClick={handleHide} />
                </h2>

                <div className="popup-container x2">

                    <div className="col">
                        <label>
                            {trans('labels.name')}
                        </label>
                        <input
                            id="name"
                            type="text"
                            name="name"
                            value={popup.data && popup.data.name ?
                                popup.data.name
                                :
                                ''
                            }
                            className={validations && validations.name ? 'validate' : ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="col">
                        <label>
                            {trans('labels.technicians')}
                        </label>
                        <MultiSelect
                            options={employees.data}
                            value={popup.data.selectedEmployees}
                            onChange={handleEmployeesChange}
                            hasSelectAll={false}
                            disableSearch={true}
                            overrideStrings={{
                                "selectSomeItems": trans('labels.choose'),
                                "allItemsAreSelected": trans('labels.allSelected'),
                                "selectAll": trans('labels.selectAll'),
                                "search": trans('labels.search')
                            }}
                        />

                        {popup.data.selectedEmployees.map(s =>
                            <input key={'m-' + s.value} type="hidden" name="employees[]" value={s.value} />
                        )}
                    </div>
                </div>


                <div className="footer align-center">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(AddOrEditGroup);